import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { AlertAction } from "@/components/AlertAction";
import { AlertTriangle } from "lucide-react";
import { missingInvoiceData } from "@/lib/applyVisura";

export function InvoiceDataCheck() {
  const [missing, setMissing] = useState(null);
  useEffect(() => { api.get("/account/profile").then((r) => setMissing(missingInvoiceData(r.data.data))).catch(() => setMissing(null)); }, []);
  if (!missing?.length) return null;
  return (
    <Card className="compact-actions px-3 py-2 border-amber-500/40 bg-amber-500/5 flex items-center gap-2.5 min-h-[52px]" role="alert" data-testid="invoice-data-missing">
      <AlertTriangle className="w-4 h-4 text-amber-500 shrink-0" />
      <p className="flex-1 min-w-0 text-xs sm:text-sm leading-snug line-clamp-2 sm:line-clamp-1" title={`Dati fattura mancanti: ${missing.join(" · ")}`}>
        <span className="font-semibold">Dati fattura mancanti:</span> <span className="text-muted-foreground" data-testid="invoice-data-missing-list">{missing.join(" · ")}</span>
      </p>
      <AlertAction to="/app/documenti" tone="outline" testid="invoice-data-visura">Visura</AlertAction>
      <AlertAction to="/app/account" testid="invoice-data-complete">Completa</AlertAction>
    </Card>
  );
}
